module.exports = __webpack_public_path__ + "img/polymers.b6abc77f.png";